// extracted by mini-css-extract-plugin
module.exports = {"swicthTabWrap":"JT5wZ","tab":"e0zVm","active":"JmYza","partyInfoWrap":"VUpaD"};